// Firebase 12 reports a wrong email or password as auth/invalid-credential
// (or auth/invalid-login-credentials); older SDKs used the first two codes.
export const INVALID_CREDENTIAL_CODES: string[] = [
  'auth/wrong-password',
  'auth/user-not-found',
  'auth/invalid-credential',
  'auth/invalid-login-credentials',
];
